import Utils from './Utils'
import Cookies from 'js-cookie'

class Product {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this._utils = new Utils()
        this._formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'GBP'
        })
        this.jsonProduct = null
        try {
            this.jsonProduct = window.jsonProduct
        } catch (e) {
        }
    }

    onInit () {
        this.modelError()
        this.initVariantSelector()
        this.updateVariantDisplay()
        this.initStickySelector()
        this.updatePropertyImage()
        this.initQuantityConnect(true)
        this.initAddToCart()
        this.initUpsellPopup()
        this.addToRecentlyViewed()
    }

    modelError () {
        let modelViewers = this._elem.querySelectorAll('model-viewer')
        modelViewers.forEach(function (el) {
            el.addEventListener('ar-status', (event) => {
                if (event.detail.status === 'failed') {
                    const error = el.querySelector('.model-error')
                    error.classList.remove('hide')
                    error.addEventListener('transitionend', (event) => {
                        error.classList.add('hide')
                    })
                }
            })
        })
    }

    updateProductWithVariant () {
        // If no selected variant or variant is unavailable - turn off add to cart
        let _this = this

        // When variant options are selected, find variant ID and update add to cart form
        let selectedObj = {'option1': null, 'option2': null, 'option3': null}
        this._elem.querySelectorAll('.product-form-option input:checked').forEach(function (selected) {
            let selectedOptionName = selected.getAttribute('data-option-num')
            selectedObj[selectedOptionName] = selected.value
        })
        let selectedVaraint = _this.jsonProduct['variants'].find(x => x.option1 === selectedObj['option1'] && (x.option2 === selectedObj['option2'] || x.option2 == null) && (x.option3 === selectedObj['option3'] || x.option3 == null))
        if (selectedVaraint) {
            this._elem.querySelector('#ProductSelect-product-template').value = selectedVaraint.id
            _this.updatePriceAndAvailable()
        } else {
            _this.updateUnavailable()
        }
    }

    updateUnavailable () {
        let sticky = this._elem.querySelector('.product-sticky')
        let body = document.querySelector('body')
        document.querySelectorAll('.add-to-cart-button').forEach(function (el) {
            el.setAttribute('disabled', true)
            el.innerHTML = 'UNAVAILABLE'
        })
        document.querySelectorAll('.product-price').forEach(function (el) {
            el.innerHTML = 'UNAVAILABLE'
        })
        // Check the button text changing hasn't caused the sticky add-to-cart visual issues
        let stickyHeight = sticky.offsetHeight
        this.stickyShowToggle(body, stickyHeight)
    }

    updatePriceAndAvailable () {
        let select = this._elem.querySelector('.product-form-variants')
        let price = select.options[select.selectedIndex].getAttribute('data-amount')
        let newPrice = this._formatter.format(parseInt(price)).replace(/\D00$/, '')
        let available = select.options[select.selectedIndex].getAttribute('data-available')
        let availableBool = (available === 'true')
        let sticky = this._elem.querySelector('.product-sticky')
        let body = document.querySelector('body')

        // Update all add to carts based on if variant is available
        document.querySelectorAll('.add-to-cart-button').forEach(function (el) {
            if (availableBool) {
                el.removeAttribute('disabled')
            } else {
                el.setAttribute('disabled', !availableBool)
            }
            el.innerHTML = availableBool ? el.getAttribute('data-button-text') : 'SOLD OUT'
        })

        // Update all product prices based on the price of the variant
        document.querySelectorAll('.product-price').forEach(function (el) {
            el.innerHTML = newPrice.toLocaleString()
        })

        // Check the button text changing hasn't caused the sticky add-to-cart visual issues
        let stickyHeight = sticky.offsetHeight
        this.stickyShowToggle(body, stickyHeight)
    }

    updateVariantDisplay () {
        let _this = this
        let productFormOptions = _this._elem.querySelectorAll('.product-form-option')

        // Update main variant options design
        productFormOptions.forEach(function (el) {
            if (el.querySelector('input').checked === true) {
                el.classList.add('product-form__option--selected')
                // When main variant options are updated, sticky variant options are updated too
                _this.updateStickySelector(el.querySelector('input'))
            } else {
                el.classList.remove('product-form__option--selected')
            }
        })
    }

    initVariantSelector () {
        let _this = this
        let productFormOptions = _this._elem.querySelectorAll('.product-form-option')

        productFormOptions.forEach(function (el) {
            el.addEventListener('change', function () {
                _this.updateVariantDisplay()
                _this.updateProductWithVariant()
            })
        })
    }

    updateStickySelector (el) {
        // Update sticky select value
        let reference = el.getAttribute('data-reference')
        let value = el.getAttribute('value')
        this._elem.querySelector(reference).value = value
    }

    updatePropertyImage () {
        let _this = this
        // Update all sticky custom property images
        this._elem.querySelectorAll('.product-form-sticky').forEach(function (el) {
            let selectedOption = el.options[el.selectedIndex]
            let imageReference = el.getAttribute('data-image-reference')
            // Update custom property image
            if (imageReference) {
                let imageUrl = selectedOption.getAttribute('data-image')
                if (imageUrl) {
                    _this._elem.querySelector(imageReference).src = imageUrl
                }
            }
        })
    }

    stickyShowToggle (body, stickyHeight, distanceToTop) {
        if (stickyHeight < 75 && window.scrollY > distanceToTop) {
            body.classList.remove('sticky-product-hide')
        } else {
            body.classList.add('sticky-product-hide')
        }
    }

    initStickySelector () {
        let _this = this
        let sticky = this._elem.querySelector('#product-sticky')
        let body = document.querySelector('body')
        let stickyHeight = sticky.offsetHeight
        let addToCartButton = document.getElementById('add-to-cart-button')
        let addToCartButtonDistance = addToCartButton.getBoundingClientRect().top

        // If width of all elements in sticky selector is wider than screen, hide sticky
        this.stickyShowToggle(body, stickyHeight, addToCartButtonDistance)
        window.addEventListener('resize', function () {
            stickyHeight = sticky.offsetHeight
            _this.stickyShowToggle(body, stickyHeight, addToCartButtonDistance)
        })

        // Add scroll listener
        document.addEventListener('scroll', function (e) {
            stickyHeight = sticky.offsetHeight
            _this.stickyShowToggle(body, stickyHeight, addToCartButtonDistance)
        })

        // When main custom properties are updated, sticky custom properties are updated too
        this._elem.querySelectorAll('.product-sticky-target').forEach(function (el) {
            el.addEventListener('change', function () {
                _this.updateStickySelector(el)
                _this.updatePropertyImage()
            })
        })

        // When sticky variant or custom options are updated, main variant or custom options are updated too
        this._elem.querySelectorAll('.product-form-sticky').forEach(function (el) {
            el.addEventListener('change', function (select) {
                let selectedOption = el.options[el.selectedIndex]
                let selectedOptionRef = selectedOption.getAttribute('data-reference')
                _this._elem.querySelector(selectedOptionRef).checked = true
                _this.updateVariantDisplay()
                _this.updateProductWithVariant()
                _this.updatePropertyImage()
            })
        })
    }

    initQuantityConnect (initial) {
        // Update all quantity selectors when one is updated
        let allInputs = document.querySelectorAll('.sticky-number-input')

        function updateQuantityConnect (el, allInputs) {
            let updatedValue = el.value
            allInputs.forEach(function (input) {
                input.value = updatedValue
            })
        }

        if (initial === true) {
            allInputs.forEach(function (el) {
                el.addEventListener('change', function () {
                    updateQuantityConnect(el, allInputs)
                })
            })
        } else {
            allInputs.forEach(function (el) {
                updateQuantityConnect(el, allInputs)
            })
        }
    }

    initAddToCart () {
        let addToCart = this._elem.querySelector('.product-add-cart-form')
        let stickyAddToCart = this._elem.querySelector('.product-sticky-submit')
        let _this = this

        addToCart.addEventListener('submit', function (e) {
            e.preventDefault()
            _this.submitForm(e.target)
        }, false)

        stickyAddToCart.addEventListener('click', function (e) {
            _this.submitForm(addToCart)
        })
    }

    submitForm (form) {
        let _this = this
        let formData = new FormData(form)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '/cart/add')
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                _this.showUpsellPopup()
                _this._utils.updateCartCounter()
            }
        }
        xhr.onerror = function () {
            console.log(xhr.response)
        }
        xhr.send(formData)
    }

    initUpsellPopup () {
        let overlay = document.querySelector('#product-overlay')
        let body = document.querySelector('body')
        let html = document.querySelector('html')

        if (overlay) {
            document.addEventListener('click', function (e) {
                if (e.target.classList.contains('product-overlay') || e.target.classList.contains('product-overlay__close')) {
                    body.classList.remove('overflow-hidden')
                    html.classList.remove('overflow-hidden')
                    overlay.classList.add('product-overlay--hide')
                }
            })
        }
    }

    showUpsellPopup () {
        let overlay = document.querySelector('#product-overlay')
        let body = document.querySelector('body')
        let html = document.querySelector('html')

        this.initUpsell(overlay)
        body.classList.add('overflow-hidden')
        html.classList.add('overflow-hidden')
        overlay.classList.remove('product-overlay--hide')
    }

    initUpsell (overlay) {
        let upsellSelectors = this._elem.querySelectorAll('.product-upsell-option')
        let selectedOptionsText = overlay.querySelector('.upsell-selected-options')
        let selectedText = ''

        upsellSelectors.forEach(function (el) {
            let selectorName = el.getAttribute('data-upsell-option')
            let selectorValue = el.querySelector('input:checked').value
            selectedText = selectedText + `<span class="product-upsell__option-name">${selectorName}: </span><span class="product-upsell__option-value">${selectorValue} </span><span class="product-upsell__option-block"></span>`
        })

        selectedOptionsText.innerHTML = selectedText
    }

    addToRecentlyViewed () {
        let viewedProducts = Cookies.get('viewed-products')
        if (viewedProducts) {
            let viewedHandlesArr = viewedProducts.split('###')
            let _this = this

            if (this.jsonProduct['handle']) {
                viewedHandlesArr = viewedHandlesArr.filter(function (value, index, arr) { return value !== _this.jsonProduct['handle'] })
                viewedHandlesArr.push(this.jsonProduct['handle'])
                if (viewedHandlesArr.length > 7) {
                    viewedHandlesArr.pop()
                }
            }

            let newViewedArr = viewedHandlesArr.join('###')
            Cookies.set('viewed-products', newViewedArr)
        } else {
            Cookies.set('viewed-products', this.jsonProduct['handle'])
        }
    }
}

export default Product



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Products.js